import * as React from 'react';

import type {SavedFilter} from 'nutshell-core/types';

import {Button} from 'shells/button/button';
import {CloseButton} from 'shells/button/close-button/close-button';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Popover} from 'shells/popover/popover';

import type {ShareType} from './share-selection';
import {ShareSelectionComponent} from './share-selection';

import styles from './filter-share-popover.module.css';

type Props = {
    anchor: HTMLElement;
    location: string;
    onSave: (arg1: boolean, arg2: Array<any>) => any;
    onClose: () => any;
    isSaving: boolean;
    title: string;
    errorText?: string | null | undefined;
    savedFilter: SavedFilter<any>;
    onDismissError: () => any;
};

type State = {
    shareType: ShareType;
};

export class FilterSharePopover extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            shareType: !props.savedFilter || !props.savedFilter.isShared ? 'nobody' : 'everyone',
        };
    }

    render() {
        const hasError = this.props.errorText && this.props.errorText.length;

        return (
            <Popover
                className={`ui-popover ui-popover--filter-save ui-popover-form ${
                    hasError ? 'has-error-banner' : ''
                }`}
                anchor={this.props.anchor}
                // @ts-expect-error
                location={this.props.location}
                onBlur={this.props.onClose}
            >
                {hasError ? (
                    <FlashBanner
                        type='error'
                        duration={4000}
                        isOverlay={true}
                        onHidden={this.props.onDismissError}
                    >
                        {this.props.errorText}
                    </FlashBanner>
                ) : undefined}
                <div className='toolbar'>
                    <h1 className='ui-header ui-header--md'>{this.props.title}</h1>
                </div>
                <form onSubmit={this.handleSubmit} className='inner-wrapper'>
                    <CloseButton className='ui-btn__popover-close' onClick={this.props.onClose} />
                    <ShareSelectionComponent
                        shareType={this.state.shareType}
                        onChangeShareType={this.handleShareTypeChange}
                        canShareWithIndividuals={false}
                    />
                    <div className={styles.buttons}>
                        <Button type='submit' variant='save' size='big' onClick={this.handleSubmit}>
                            {this.props.isSaving ? 'Updating…' : 'Save'}
                        </Button>
                    </div>
                </form>
            </Popover>
        );
    }

    handleShareTypeChange = (shareType: ShareType) => {
        this.setState({shareType: shareType});
    };

    handleSubmit = (e: React.SyntheticEvent<any>) => {
        e.preventDefault();
        this.props.onSave(this.state.shareType !== 'nobody', []);
    };
}
